import { DEV_MODE } from '../../global/env';
import { Logger } from '../logger';
/**
 * Handles managing multiple context consumers on a given DOM element (`ref`).
 */
export class ContextConsumerManager {
    constructor(_host) {
        this._host = _host;
        this._hasHostConnected = false;
        this._consumers = new Map();
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger = new Logger(_host, { owner: this });
        }
        /* c8 ignore stop */
        if (_host instanceof Element)
            this.setRef(_host);
        _host.addController(this);
    }
    setRef(newRef) {
        if (this._ref !== newRef) {
            this._handleRefChange(newRef);
        }
    }
    _handleRefChange(newRef) {
        this._consumers.forEach((consumer) => {
            consumer.stop();
            consumer.setRef(newRef);
            if (this._hasHostConnected)
                consumer.start();
        });
        this._ref = newRef;
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger.debug('ref change', newRef);
        }
        /* c8 ignore stop */
    }
    hostConnected() {
        this._hasHostConnected = true;
        this._consumers.forEach((consumer) => consumer.start());
    }
    hostDisconnected() {
        this._hasHostConnected = false;
        this._consumers.forEach((consumer) => consumer.stop());
    }
    addContext(context) {
        if (this._consumers.has(context))
            return this._consumers.get(context);
        let init = false;
        const consumer = context.consume(this._host, {
            onConnect: () => {
                if (init)
                    this._handleContextConnect(consumer);
            },
            onUpdate: () => {
                if (init)
                    this._handleContextUpdate(consumer);
            },
            onDisconnect: () => {
                if (init)
                    this._handleContextDisconnect(consumer);
            }
        });
        init = true;
        // First pass won't be called since `init` would be false.
        if (consumer.isConnected) {
            this._handleContextConnect(consumer);
            this._handleContextUpdate(consumer);
        }
        consumer.setRef(this._ref);
        if (this._hasHostConnected)
            consumer.start();
        this._consumers.set(context, consumer);
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger
                .debugGroup('added context')
                .appendWithLabel('Context', context)
                .appendWithLabel('Consumer', consumer)
                .end();
        }
        /* c8 ignore stop */
        return consumer;
    }
    removeContext(context) {
        const consumer = this._consumers.get(context);
        consumer === null || consumer === void 0 ? void 0 : consumer.stop();
        this._consumers.delete(context);
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger
                .debugGroup('removed context')
                .appendWithLabel('Context', context)
                .appendWithLabel('Consumer', consumer)
                .end();
        }
        /* c8 ignore stop */
    }
}
